import type { RouteRecordRaw } from 'vue-router'

import useHasPermissionUser from '@/composables/useHasPermissionUser'
import { useConfirmationsStore } from '@/stores/confirmations'

import HotelDetails from '@/modules/hotels/pages/HotelDetails.vue'
import HotelRate from '@/modules/hotels/pages/HotelRate.vue'

import AvailabilityPage from '../pages/AvailabilityPage.vue'

export default {
	path: '/services/hotel',
	redirect: '/services/hotel/availability',
	children: [
		{
			path: 'availability',
			name: 'hotel.availability',
			component: AvailabilityPage,
			beforeEnter: (to, from, next) => {
				const { hasPermissionUser } = useHasPermissionUser()

				if (hasPermissionUser('create-hotel', 'App\\Models\\Request')) {
					return next()
				} else {
					return next({
						path: '/error/not-found',
					})
				}
			},
		},
		{
			path: 'details',
			name: 'hotel.details',
			component: HotelDetails,
		},
		{
			path: 'rate',
			name: 'hotel.rate',
			component: HotelRate,
		},
		{
			path: 'reservation',
			name: 'hotel.reservation',
			component: () => import('@/modules/hotels/pages/ReservationPage.vue'),
			meta: {
				serviceName: 'Hotel',
			},
			// beforeEnter: (to, from, next) => {
			// 	const { reservation } = useReservationStore()
			// 	const { user } = useAuth()

			// 	if (!reservation && !user.value?.internal) {
			// 		return next({
			// 			name: 'hotel.availability',
			// 		})
			// 	} else {
			// 		return next()
			// 	}
			// },
		},
		{
			path: '/internal/reservation',
			name: 'hotel.internal.reservation',
			component: () =>
				import('@/modules/hotels/pages/ResevationInternalPage.vue'),
			meta: {
				serviceName: 'Hotel',
			},
		},
		{
			path: 'confirmation',
			name: 'hotel.confirmation',
			component: () =>
				import('@/modules/hotels/pages/HotelConfirmationPage.vue'),
			beforeEnter: (to, from, next) => {
				const store = useConfirmationsStore()
				const hasSession = Boolean(sessionStorage.getItem('hotelBookingResult'))
				if (store.confirmations.length === 0 && !hasSession) {
					next({ name: 'hotel.availability' })
				} else {
					next()
				}
			},
		},
	],
} as RouteRecordRaw
